import { createSelector } from 'reselect';
import type { Selector } from 'reselect';

import type { IAddress, IAddressesState } from './types';

export const selectAddresses = (state: IAddressesState) => state.addresses;

export const selectIndexedAddresses = createSelector(selectAddresses, (addresses) =>
  addresses.reduce((indexed: { [x: number]: any }, address: IAddress) => {
    if (address.addressNumber) {
      indexed[address.addressNumber] = address;
    }
    return indexed;
  }, {})
);

export const selectAddress: Selector<IAddressesState> = createSelector(
  [selectIndexedAddresses, (_: IAddressesState, addressNumber: number) => addressNumber],
  (indexedAddresses, addressNumber) => indexedAddresses[addressNumber]
);
